import api from "@/lib/api";

const cache = {};
const EMPTY = { items: [], keywords: [], defaults: {} };

export function loadKop(lang) {
  if (!cache[lang]) {
    cache[lang] = api.get(`/kop?lang=${lang}`).then(({ data }) => data).catch(() => { delete cache[lang]; return EMPTY; });
  }
  return cache[lang];
}

// Same rule as the backend: KOP of the tax type, else (PPh 23) a keyword match on the description / ledgers.
export function autoKop(ref, tax, text) {
  if (!tax || !ref) return "";
  const k = "kop" in tax ? tax.kop || "" : ref.defaults[tax.std_key || tax.code] || "";
  if (k || tax.group !== "PPH23") return k;
  const s = (text || "").toLowerCase();
  const hit = ref.keywords.find(([rx]) => new RegExp(rx).test(s));
  return hit ? hit[1] : "";
}

export function tkuOf(npwp, nik) {
  let d = String(npwp || "").replace(/\D/g, "") || String(nik || "").replace(/\D/g, "");
  if (d.length === 15) d = `0${d}`;
  return d.length === 16 ? `${d}000000` : "";
}
